export default __webpack_public_path__ + "static/media/FSK_Lunch_Menu.d65f8e97.pdf";